import { buildApiUrl } from '../utils/apiConfig';
import { BioSection } from '../types/aboutBios';
import { apiClient } from "../utils/apiClient";

export async function fetchAboutBios(): Promise<BioSection | null> {
    try {
        const response = await apiClient(buildApiUrl('api/cms/about/bios'), {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch about bios: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching about bios:', error);
        return null;
    }
}
